<template>
    <div>
        <h3 class="mt-0">{{ item.name }}</h3>
        <p class="text-justify" v-if="item.description">
            <strong v-if="progressCheck">{{ lang.polaris.dashboard.progress_check }} - </strong>
            {{ item.description }}
        </p>
        <p v-else-if="progressCheck">
            <strong>{{ lang.polaris.dashboard.progress_check }}</strong>
        </p>

        <div v-html="statusHtml"></div>
        
        <div class="text-center mt-4">
            <a :href="viewLink" class="btn btn-round btn-default" v-if="viewAllowed">
                {{ lang.polaris.dashboard.details }}
            </a>
            <a :href="editLink" class="btn btn-round btn-primary" v-if="editAllowed">
                {{ lang.polaris.dashboard.edit }}
            </a>
        </div>

        <div class="mt-5" v-if="mustShowWorkToBeDone">
            <h6 class="section-title text-center py-2 mb-3" >
                Limitations
            </h6>
            <div class="row">
                <div class="col-xl-6">
                    <p>
                        <strong>Visibility:</strong>
                        {{ visibility }}
                    </p>
                    <p>
                        <strong>Ceiling:</strong>
                        {{ ceiling }}
                    </p>
                    <p>
                        <strong>Max Crosswind:</strong>
                        {{ maxCrosswind }}
                    </p>
                </div>
                <div class="col-xl-6">
                    <p>
                        <strong>Max Effective Wind:</strong>
                        {{ maxEffectiveWind }}
                    </p>
                    <p>
                        <strong>Risk Assessment Score:</strong>
                        {{ riskAssessmentScore }}
                    </p>
                </div>
            </div>
            <h6 class="section-title text-center py-2 mt-2 mb-3" >
                Type of Flight
            </h6>
            <div class="row">
                <div class="col-xl-6">
                    <p>
                        <strong>Manoeuvrability:</strong>
                        {{ manoeuvrability }}
                    </p>
                    <p>
                        <strong>Cross Country:</strong>
                        {{ crossCountry }}
                    </p>
                </div>
                <div class="col-xl-6">
                    <p>
                        <strong>Night:</strong>
                        {{ night }}
                    </p>
                </div>
            </div>
            <h6 class="section-title text-center py-2 mt-2 mb-3" >
                Work to be Completed
            </h6>
            <p class="mb-4" style="white-space:pre-wrap;">{{ workToBeCompleted }}</p>
        </div>
    </div>
</template>

<script>
    export default {
    
        props: {
            id: null,
            bus: null
        },
    
        data() {
            return {
                lang: lang,
                user: user,
                locations_names_uuid: data.locations_names_uuid,
                registration: data.registration,
                learner: data.learner,
                learning_unit_dashboard_routes: data.learning_unit_dashboard_routes,
                item: {meta: {}}
            }
        },

        computed: {

            mustShowWorkToBeDone() {
                return this.item.meta.crew_type == 'solo'
                    && this.item.state
                    && this.item.state.completed
                    && !this.item.state.validation
            },

            visibility() {
                return this.item.state && this.item.state.visibility ? this.item.state.visibility : ''
            },

            ceiling() {
                return this.item.state && this.item.state.ceiling ? this.item.state.ceiling : ''
            },

            maxCrosswind() {
                return this.item.state && this.item.state.max_crosswind ? this.item.state.max_crosswind : ''
            },

            maxEffectiveWind() {
                return this.item.state && this.item.state.max_effective_wind ? this.item.state.max_effective_wind : ''
            },

            riskAssessmentScore() {
                return this.item.state && this.item.state.risk_assessment_score ? this.item.state.risk_assessment_score : ''
            },

            manoeuvrability() {
                return this.item.state && this.item.state.manoeuvrability ? 'Yes' : 'No'
            },

            crossCountry() {
                return this.item.state && this.item.state.cross_country ? 'Yes' : 'No'
            },

            night() {
                return this.item.state && this.item.state.night ? 'Yes' : 'No'
            },

            workToBeCompleted() {
                return this.item.state && this.item.state.work_to_be_completed ? this.item.state.work_to_be_completed : ''
            },

            conditionsSatisfied() {
                return this.item.conditions && this.item.conditions.lrConditionSatisfied;
            },

            viewAllowed() {
                if (this.item.type == 'enac-atpl-self-paced') return true;
                if (!this.viewEnabled) return false;
                if (!this.conditionsSatisfied) return false;
                return true;
            },
        
            editAllowed() {
                if (this.item.type == 'enac-atpl-self-paced') return false;
                if (!this.conditionsSatisfied) return false;
                return !this.viewEnabled && this.editDashboardPermission && this.editDashboardStatus;
            },
        
            viewEnabled() {
                return this.item.state && this.item.state.validation;
            },
        
            statusHtml() {
                if (!this.conditionsSatisfied) {
                    var html = '<h6 class="mb-4 mt-4 text-left text-danger">';
                    html += 'Some level reports have not been completed before this session!';
                    html += '</h6>';
                    return html;
                }
            
                if (!this.item.state) return '';

                var html = '<div class="mb-4 mt-4">';
                
                //Status.
                html += this.formatStatus(this.statusLabel, this.item.state.color_status, this.item.state.grade, this.item.state.grade_max);

                html += '<div class="row text-center">';

                // Date.
                if (this.item.state.date) {
                    html += '<div class="col-md"><h6><i class="material-icons">event</i> ' + moment(this.item.state.date).format('DD MMM YYYY') + '</h6></div>';
                }

                // Location.
                if (this.item.state.location) {
                    var name = this.locations_names_uuid[this.item.state.location.entity_uuid];
                    if (!name) name = this.item.state.location.entity_name;
                    html += '<div class="col-md"><h6><i class="material-icons">location_on</i> '+name+'</h6></div>';
                }
                html += '</div>';

                // Author.
                if (this.item.state.validation || (this.item.state.author && this.item.state.author.user_uuid)) {
                    var author = this.item.state.validation ? this.item.state.validation : this.item.state.author
                    html += '<div class="row text-center">';
                    html += '<div class="col-md"><h6 class="mb-1"><i class="material-icons">edit</i> '+author.user_name+'</h6></div>';
                    html += '</div>';
                }

                html += '</div>';
                return html;
            },
        
            statusLabel() {
                if (this.item.state.partially_passed) {
                    return this.lang.polaris.dashboard.partial_pass;
                } else if (this.item.state.passed != undefined) {
                    if (this.item.type == 'enac-atpl-level-report') {
                        return this.item.state.passed ? this.lang.polaris.dashboard.satisfactory : this.lang.polaris.dashboard.unsatisfactory;
                    } else {
                        return this.item.state.passed ? this.lang.polaris.dashboard.pass : this.lang.polaris.dashboard.fail;
                    }
                } else if (this.item.state && this.item.state.completed) {
                    if (this.item.type == 'enac-atpl-level-report') {
                        return '';
                    } else if (this.item.type == 'enac-atpl-course-session') {
                        return this.lang.polaris.dashboard.attended;
                    } else if (this.mustShowWorkToBeDone) {
                        return this.lang.polaris.dashboard.in_progress;
                    } else {
                        return this.lang.polaris.dashboard.completed;
                    }
                }
            },
        
            progressCheck() {
                return this.item.meta.assessment;
            },
        
            viewLink() {
                var routes = this.learning_unit_dashboard_routes;
                var href = routes[this.item.type]+'/registration/'+this.registration.id+'/'+this.item.type+'/'+this.item.id;
                if (this.learner) {
                    href += '/learner/'+this.learner.id;
                }
                return href;
            },
        
            editLink() {
                return this.viewLink + '/edit';
            },

            collectiveDashboardPermission() {
                return this.user.admin || this.user.permissions['dashboard.read-all'] || this.user.permissions['dashboard.read-mine-locations']
                    || this.user.permissions['dashboard.read-mine-collaborators'] || this.user.permissions['dashboard.write-all']
                    || this.user.permissions['dashboard.write-mine-locations'] || this.user.permissions['registration.manage'];
            },

            editDashboardPermission() {
                return this.user.admin || this.user.permissions['dashboard.write-all'] || this.user.permissions['dashboard.write-mine-locations'];
            },

            editDashboardStatus() {
                return this.registration.status != 'draft' && this.registration.status != 'archived';
            }
        },

        created() {
            this.bus.$on(this.id+'-open', this.open);
        },

        methods: {
        
            open(event) {
                this.item = event.data;
            },

            formatStatus(text, color, grade, grade_max) {
                if (grade != undefined) {
                    var html = '<h2 class="text-center text-'+color+' font-weight-bold text-uppercase mb-3">';
                    html += grade;
                    if (grade_max != undefined) html += '/'+grade_max;
                    html += '</h2>';
                } else {
                    var html = '<h3 class="text-center text-'+color+' font-weight-bold text-uppercase mb-3">';
                    html += text;
                    html += '</h3>';
                }
                return html;
            }

        }

    }
</script>

<style scoped>

    .section-title {
        background-color: rgba(200,200,200,0.2);
    }

</style>